import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as AuthStore from '../../app/store/AuthStore';
import useSimpleOffline from '../../youwell-common/useSimpleOffline';

const StartSession = () => {
    const dispatch = useDispatch();
    const appConfig = useSelector(state => state.pageSettings.appConfig);
    const isOffline = useSimpleOffline();

    useEffect(() => {
        if (!isOffline) {
            dispatch(AuthStore.actionCreators.startSession({
                orgId: appConfig.orgId,
                anonymous: appConfig.useAnonymousSessions,
            }, { background: true }));
        }
    }, [appConfig, dispatch, isOffline]);

    return null;
};

export default StartSession;
